<footer class="footer">
  <div class="container">
    <div class="footer-box">
      <div class="footer-info">
        <a
          class="footer-info__link link"
          href="https://www.controlinsurancesolutions.com.au/"
          target="_blank">
          ©{{ year }} Control Insurance Solutions Pty Ltd. All rights reserved.
        </a>
      </div>
    </div>
  </div>
</footer>
